import { gameState } from "appworks/model/game-state";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export class IsTGRFirstFreespin extends Decision {

    public evaluate(): Exit {
        const rootRec: SpinRecord = gameState.getCurrentGame().getRootRecord() as SpinRecord;
        const currentRec: SpinRecord | FreespinRecord = gameState.getCurrentGame().getCurrentRecord() as SpinRecord | FreespinRecord;
        if (rootRec.hasChildren) {
            if (currentRec instanceof FreespinRecord && rootRec.currentChildIndex === 0 && rootRec.children[0] === currentRec) {
                return Exit.True;
            }
        }
        return Exit.False;
    }
}
